import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_NOTIFICATION_BOOKING, GET_NOTIFICATION_BOOKING_ERROR, GET_NOTIFICATION_BOOKING_SUCCESS } from '../../../actions.js';

function* getNotificationBooking({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/vendor/booking-notifications`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_NOTIFICATION_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_NOTIFICATION_BOOKING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_NOTIFICATION_BOOKING_ERROR, payload: error });
  }
}

export function* watchGetNotificationBooking() {
  yield takeEvery(GET_NOTIFICATION_BOOKING, getNotificationBooking);
}

function* getNotificationBookingSaga() {
  yield all([fork(watchGetNotificationBooking)]);
}

export default getNotificationBookingSaga;
